var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkuTracker(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7694.914 -1674.674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7695.406 1692.739a.492.492 0 00.492-.492v-15.082a.492.492 0 00-.983 0v15.082a.492.492 0 00.491.492zM7698.028 1692.739a.492.492 0 00.492-.492v-15.082a.492.492 0 00-.983 0v15.082a.492.492 0 00.491.492zM7711.799 1692.739a.492.492 0 00.492-.492v-15.082a.492.492 0 00-.983 0v15.082a.492.492 0 00.491.492zM7714.422 1676.674a.492.492 0 00-.492.492v15.082a.492.492 0 00.983 0v-15.082a.492.492 0 00-.491-.492zM7705.242 1692.739a.492.492 0 00.492-.492v-15.082a.492.492 0 00-.983 0v15.082a.492.492 0 00.491.492z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 16,
    rx: 1,
    transform: "translate(7700.914 1676.674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 16,
    rx: 1.5,
    transform: "translate(7706.914 1676.674)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkuTracker);
export default __webpack_public_path__ + "static/media/SKUTracker.4efc00893c9667e7ddf76a4676049640.svg";
export { ForwardRef as ReactComponent };